import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pages from "../../constant/ReportModel";
import { setShowReport, setSelectedChat } from "../../redux/actions/actions";
import { ArrowBackIosNew, MoreVert } from "@mui/icons-material";
import { English } from "../../constant/EnglishFallback";
import { getPictureUrl } from "../../common/Helper";
import {
  IconButton,
  MenuItem,
  Stack,
  Typography,
  Menu,
  Box,
  Avatar,
  ListItemAvatar,
  useMediaQuery
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PromptModal from "../common/PromptModal";
import { GET_MY_CHAT_GROUPS_USERS, MUTE_CHAT_GROUP } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import ShowMembersModal from "./ShowMembersModal";
import { BIBlue, BIRed } from "../../assets/helpers";
import BuildIdEvent from "../../common/BuildIdEvent";
import { Getrequestcall } from "../../request/Getrequest";

export default function ChatHeader({ updateChatList, handleLeaveChatGroup }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const buildIdEvent = BuildIdEvent();
  const { multiLanguageData, loginData, selectedChat } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.Chat || {};
  const {
    BUTTON_REPORT = English?.Chat?.BUTTON_REPORT,
    TEXT_SHOW_MEMBERS = English?.Chat?.TEXT_SHOW_MEMBERS,
    TEXT_UNMUTE_NOTIFICATION = English?.Chat?.TEXT_UNMUTE_NOTIFICATION,
    TEXT_MUTE_NOTIFICATION = English?.Chat?.TEXT_MUTE_NOTIFICATION,
    TEXT_LEAVE_CHAT = English?.Chat?.TEXT_LEAVE_CHAT,
    TEXT_VIEW_PROFILE = English?.Chat?.TEXT_VIEW_PROFILE,
    TEXT_DELETE_CHAT = English?.Chat?.TEXT_DELETE_CHAT,
    TEXT_MASSAGE_CONFIMATION = English?.Chat?.TEXT_MASSAGE_CONFIMATION,
    TEXT_DESC_CONFIRMATION = English?.Chat?.TEXT_DESC_CONFIRMATION
  } = LanguageData || {};

  const [membersModalOpen, setMembersModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const isCurrentUser = selectedChat?.mostRecentUserId1 === loginData?.userInformation?.UserId;
  const isGroupChat = selectedChat?.nrOfUsersInGroup > 2;

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleViewProfile = async () => {
    handleMenuClose();
    try {
      const res = await Getrequestcall(
        `${GET_MY_CHAT_GROUPS_USERS}/${loginData?.userInformation?.UserId}/${selectedChat?.chatGroupId}`,
        loginData?.accessToken
      );
      if (res?.data?.data?.length === 0) {
        navigate(`/${loginData?.userInformation?.UserId}`);
        return;
      }
      navigate(`/${res?.data?.data[0]?.userId}`);
    } catch (error) {
      console.error("handleViewProfile -> Error fetching chat group users: ", error);
    }
  };

  const handleMemberListPressed = () => {
    setMembersModalOpen(true);
    setAnchorEl(null);
  };

  const handleViewReport = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.chat?.name,
      AppScreenId: Pages?.chat?.id,
      recordId: selectedChat?.chatGroupId ?? 0
    };
    dispatch(setShowReport(reportObj));
    setAnchorEl(null);
  };

  const handleChatAction = async (action) => {
    if (!selectedChat?.chatGroupId || !loginData?.userInformation?.UserId) {
      console.error("handleChatAction -> Missing chat or user information");
      return;
    }
    const userId = Number(loginData?.userInformation?.UserId);
    const chatGroupId = selectedChat?.chatGroupId;
    try {
      switch (action) {
        case "mute":
        case "unmute": {
          const payload = {
            UserId: userId,
            ChatGroupId: chatGroupId,
            ModifiedBy: userId,
            Muted: action === "mute"
          };

          await Postrequestcall(MUTE_CHAT_GROUP, payload, loginData?.accessToken);
          dispatch(setSelectedChat({ ...selectedChat, muted: action === "mute" }));
          const msg = `The chat "${selectedChat?.name}" has been ${action === "mute" ? "muted" : "unmuted"} successfully.`;
          updateChatList(action === "mute", chatGroupId, msg, "mute-unmute");
          break;
        }
        case "leave":
        case "delete": {
          // Send special delete message through SignalR first
          const msg =
            action === "leave"
              ? `You left the chat "${selectedChat?.name}" successfully.`
              : `The chat "${selectedChat?.name}" was deleted successfully.`;
          if (selectedChat?.nrOfUsersInGroup === 2) {
            const deleteMsgArr = [
              Number(userId),
              loginData?.userInformation?.DeviceId,
              Number(chatGroupId)
            ];
            await buildIdEvent.deleteChatGroup(deleteMsgArr);
            // Call the centralized handleLeaveChatGroup method
            await handleLeaveChatGroup(chatGroupId);
            updateChatList(action === "delete", chatGroupId, msg, "delete-chat");
          } else {
            // Call the centralized handleLeaveChatGroup method for group chats
            await handleLeaveChatGroup(chatGroupId);
            updateChatList(action === "leave", chatGroupId, msg, "leave-chat");
          }
          setAnchorEl(null);
          break;
        }
        default:
          console.warn(`handleChatAction -> Unknown action: ${action}`);
          return;
      }
    } catch (error) {
      console.error(`handleChatAction -> Error while performing "${action}":`, error);
      const msg = `Failed to ${action} chat. Please try again.`;
      updateChatList(action, chatGroupId, msg, "catch-error");
    } finally {
      handleMenuClose();
      setDeleteConfirmModalOpen(false);
    }
  };

  const renderAvatar = useMemo(() => {
    if (isGroupChat) {
      return (
        <Box sx={{ position: "relative", width: 45, height: 45 }}>
          <Avatar
            src={getPictureUrl(selectedChat?.groupUserPictureUrl1)}
            sx={{ position: "absolute", zIndex: 2, width: 38, height: 38 }}
          />
          <Avatar
            src={getPictureUrl(selectedChat?.groupUserPictureUrl2)}
            sx={{ position: "absolute", left: 20, top: 1, zIndex: 1, width: 30, height: 30 }}
          />
        </Box>
      );
    }
    return (
      <ListItemAvatar>
        <Avatar
          src={getPictureUrl(
            selectedChat?.nrOfUsersInGroup === 1 &&
              selectedChat?.fromUserId === loginData?.userInformation?.UserId
              ? loginData?.pictureUrl
              : selectedChat?.groupUserPictureUrl1
          )}
          sx={{ width: 45, height: 45 }}
        />
      </ListItemAvatar>
    );
  }, [isGroupChat, selectedChat]);

  const renderMenuItems = useMemo(() => {
    const menuItemSx = {
      color: BIBlue,
      fontSize: { xs: "0.85rem", sm: "0.95rem" }, // smaller font on mobile
      px: { xs: 1.5, sm: 2 }, // reduce horizontal padding
      py: { xs: 0.5, sm: 1 }, // reduce vertical padding
      minHeight: "unset" // remove extra height
    };

    // Hide Report and Delete options for user's own group (chatting with themselves)
    if (
      selectedChat?.fromUserId === loginData?.userInformation?.UserId &&
      selectedChat?.nrOfUsersInGroup == 1
    ) {
      return [
        <MenuItem onClick={handleViewProfile} sx={menuItemSx} key="view-profile">
          {TEXT_VIEW_PROFILE}
        </MenuItem>
      ];
    }

    const commonMenuItems = [
      <MenuItem onClick={handleViewReport} sx={{ ...menuItemSx, color: BIRed }} key="report">
        {BUTTON_REPORT}
      </MenuItem>
    ];

    const groupChatMenuItems = [
      ...commonMenuItems,
      <MenuItem onClick={handleMemberListPressed} sx={menuItemSx} key="show-members">
        {TEXT_SHOW_MEMBERS}
      </MenuItem>,
      <MenuItem
        onClick={() => {
          const action = selectedChat?.muted ? "unmute" : "mute";
          handleChatAction(action);
        }}
        sx={menuItemSx}
        key="mute-notifications">
        {selectedChat?.muted ? TEXT_UNMUTE_NOTIFICATION : TEXT_MUTE_NOTIFICATION}
      </MenuItem>,
      <MenuItem
        onClick={() => {
          setActionType("leave");
          setAnchorEl(null);
          setDeleteConfirmModalOpen(true);
        }}
        sx={{ ...menuItemSx, color: "red" }}
        key="leave-chat">
        {TEXT_LEAVE_CHAT}
      </MenuItem>
    ];

    const singleChatMenuItems = [
      ...commonMenuItems,
      <MenuItem onClick={handleViewProfile} sx={menuItemSx} key="view-profile">
        {TEXT_VIEW_PROFILE}
      </MenuItem>,
      !isCurrentUser && (
        <MenuItem
          onClick={() => {
            setActionType("delete");
            setAnchorEl(null);
            setDeleteConfirmModalOpen(true);
          }}
          sx={{ ...menuItemSx, color: "red" }}
          key="delete-chat">
          {TEXT_DELETE_CHAT}
        </MenuItem>
      )
    ];

    return isGroupChat ? groupChatMenuItems : singleChatMenuItems;
  }, [isGroupChat, selectedChat, handleViewProfile, isCurrentUser]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      className="chat-header">
      <Stack direction="row" alignItems="center" spacing={isGroupChat ? 2 : 1}>
        {isSmallScreen && (
          <ArrowBackIosNew
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={() => dispatch(setSelectedChat({}))}
          />
        )}
        {renderAvatar}
        <Typography variant="h6">{selectedChat?.name}</Typography>
      </Stack>

      <IconButton onClick={handleMenuClick} aria-controls="chat-menu" aria-haspopup="true">
        <MoreVert />
      </IconButton>

      <Menu id="chat-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        {renderMenuItems}
      </Menu>

      {deleteConfirmModalOpen && (
        <PromptModal
          isOpen={deleteConfirmModalOpen}
          onClose={() => setDeleteConfirmModalOpen(false)}
          title={
            actionType === "leave"
              ? `${TEXT_MASSAGE_CONFIMATION} ${TEXT_LEAVE_CHAT}`
              : `${TEXT_MASSAGE_CONFIMATION} ${TEXT_DELETE_CHAT}`
          }
          desc={TEXT_DESC_CONFIRMATION}
          redButtonText={actionType === "leave" ? TEXT_LEAVE_CHAT : TEXT_DELETE_CHAT}
          onRedButtonClick={() => handleChatAction(actionType)}
        />
      )}

      {membersModalOpen && (
        <ShowMembersModal open={membersModalOpen} onClose={() => setMembersModalOpen(false)} />
      )}
    </Stack>
  );
}
